
export const goToHome = (navigate, slug) => {
  navigate(`${slug}`)
}

export const goToPerfil = (navigate) => {
  navigate(`/perfil`)
}
export const goToDevolve = (navigate) => {
  navigate(`/devolve`)
}

export const goToBack = (navigate) => {
  navigate(-1)
}